// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3xUSR","buttons":"RemoveExpirationActionButtons_buttons__2Zwii"};